const lightboxModal = () => {
  const html = document.querySelectorAll('html')[0]
  const modalBox = document.getElementById('js-lightbox-modal')
  const modalBtns = document.querySelectorAll('a[href="#js-wechat-model"]')
  const closeModalBtn = document.getElementById('js-wechat-model-close')

  if (modalBtns && modalBox) {
    modalBtns.forEach((elm) => {
      elm.addEventListener('click', (e) => {
        e.preventDefault()

        const name = modalBox.querySelectorAll('.wechat-name')[0] ?? null
        const img = modalBox.querySelectorAll('.wechat-qr')[0] ?? null

        if (e.target.dataset.qr) {
          if (name) name.style = 'display: inline-block;'
          img.src = e.target.dataset.qr
        } else {
          if (name) name.style = 'display: none;'
          img.src = '/wp-content/themes/appleby/dist/img/wechat.png'
        }

        img.onload = () => {
          modalBox.classList.remove('hidden')

          html.classList.add('js-scroll-hidden')
        }
      })
    })

    closeModalBtn &&
      closeModalBtn.addEventListener('click', (e) => {
        modalBox.classList.add('hidden')

        html.classList.remove('js-scroll-hidden')
      })
  }
}

export default lightboxModal
